import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { InvestmentPortfolio } from '../../../domain/lti/investment-portfolio.domain';
import { RestService } from '../../../services/rest/rest.service';
import { LtiAccountStatus } from '../../../domain/lti/lti.enum';
import { RestOptions } from '../../../services/rest/rest-request';
import { LtiAccount } from '../../../domain/lti/lti.domain';

@Injectable({
  providedIn: 'root'
})
export class FundGoalRestService {
  private readonly restService = inject(RestService);

  /**
   * get accounts
   *
   * @return
   */
  getAccounts(): Observable<Array<LtiAccount>> {
    const restOptions: RestOptions = {
      pathVariables: {
        subtype: 'LTI'
      },
      params: {
        status: [
          LtiAccountStatus.LTI_ELIGIBLE,
          LtiAccountStatus.LTI_INELIGIBLE,
          LtiAccountStatus.LTI_OCCUPIED,
          LtiAccountStatus.LTI_UNAVAILABLE
        ]
      }
    };
    return this.restService.getResource('wealthInvestment.getInvestmentAccounts')
      .get(restOptions);
  }

  /**
   * get investment portfolios
   *
   * @return
   */
  getInvestmentPortfolios(goalId: string): Observable<Array<InvestmentPortfolio>> {
    const restOptions: RestOptions = {
      params: { goalId }
    };
    return this.restService.getResource('wealthInvestment.getInvestmentPortfolios')
      .get(restOptions);
  }

  /**
   * create investment portfolios
   *
   * @return
   */
  postInvestmentPortfolio(portfolio: InvestmentPortfolio): Observable<InvestmentPortfolio> {
    return this.restService.getResource('wealthInvestment.createInvestmentPortfolio')
      .post(portfolio);
  }

  /**
   * update investment portfolios
   *
   * @return
   */
  updateInvestmentPortfolio(portfolio: InvestmentPortfolio): Observable<InvestmentPortfolio> {
    const restOptions: RestOptions = {
      pathVariables: {
        portfolioId: portfolio.investmentPortfolioId
      }
    };
    return this.restService.getResource('wealthInvestment.patchInvestmentPortfolio')
      .patch(portfolio, restOptions);
  }
}

